import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styActionLabel = ({ transactionType }) => {
  const backgroundColor = transactionType === '1' ? colors.AJAIB_BLUE_1 : colors.RED_1;
  const color = transactionType === '1' ? colors.AJAIB_BLUE_5 : colors.RED_5;

  return css`
    border-radius: 16px;
    padding: 4px 12px;
    color: ${color};

    background-color: ${backgroundColor};

    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  `;
};

export const styLink = css`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  color: ${colors.AJAIB_BLUE_5};
`;

export const styDetail = css`
  display: flex;
  gap: 24px;
  padding: 12px;

  > div {
    display: flex;
    gap: 8px;
    flex-direction: column;

    > div {
      display: flex;
      gap: 8px;
      white-space: nowrap;

      > :first-child {
        font-weight: 700;
      }
    }
  }
`;
